import { render, staticRenderFns } from "./mcp-authorize-page.vue?vue&type=template&id=dee437ee&"
import script from "./mcp-authorize-page.vue?vue&type=script&lang=js&"
export * from "./mcp-authorize-page.vue?vue&type=script&lang=js&"
import style0 from "./mcp-authorize-page.vue?vue&type=style&index=0&id=dee437ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports